import User from "../../models/User";

export default {
    namespaced: true,
    state: {
        me: new User(),
        meIsLoaded: false,
    },
    mutations: {
        setMe(state, data) {
            state.me = data;
            state.meIsLoaded = true;
        },
        clear(state) {
            state.me = new User();
            state.meIsLoaded = false;
        },
    },
    actions: {
        async getMe({commit}) {
            const user = await User.getMe();
            commit('setMe', user);
        },
    },
}